import React, { useState } from 'react';
import { Plus, Gift, Ticket } from 'lucide-react';
import CompensationModal from './CompensationModal';

// Three-button panel shown inside the CRM customer loyalty tab. Lets an admin
// compensate a customer with loyalty points, a comped booking, or a discount code.
export default function CompensationActionsPanel({ customerEmail, customerName }) {
  const [modalType, setModalType] = useState(null); // 'points' | 'free_booking' | 'discount_code'

  const btn = 'flex items-center gap-2 px-3 py-2.5 border border-white/10 bg-[#0d0d0f] hover:border-primary/40 hover:bg-primary/5 text-white/70 hover:text-white text-xs font-bold tracking-wide transition-all duration-200';

  return (
    <>
      <div className="border border-white/5 bg-[#0d0d0f] p-4">
        <p className="text-primary text-[10px] font-bold tracking-widest mb-3">COMPENSATION ACTIONS</p>
        <div className="flex flex-wrap gap-2">
          <button className={btn} onClick={() => setModalType('points')}>
            <Plus className="w-3.5 h-3.5" /> Adjust Points
          </button>
          <button className={btn} onClick={() => setModalType('free_booking')}>
            <Gift className="w-3.5 h-3.5" /> Comped Booking
          </button>
          <button className={btn} onClick={() => setModalType('discount_code')}>
            <Ticket className="w-3.5 h-3.5" /> Issue Discount
          </button>
        </div>
      </div>

      {modalType && (
        <CompensationModal
          actionType={modalType}
          customerEmail={customerEmail}
          customerName={customerName}
          onClose={() => setModalType(null)}
        />
      )}
    </>
  );
}